var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.internalShow)?_c('div',{class:['alert-banner', `alert-banner--${_vm.color}`]},[_c('div',{staticClass:"alert-banner__container",class:{
      'alert-banner__container--limited': !!_vm.containerWidth,
    },style:({
      maxWidth: _vm.containerWidth,
    })},[_c('div',{staticClass:"alert-banner__container-inner"},[_c('span',[_vm._v(" "+_vm._s(_vm.text)+" ")]),_vm._t("action",function(){return [(_vm.link.to)?_c('sword-link',{attrs:{"to":_vm.link.to,"text":_vm.link.text}}):_vm._e()]})],2),_c('sword-icon-wuk',{attrs:{"name":"close"},nativeOn:{"click":function($event){return _vm.close.apply(null, arguments)}}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }